import { cn } from '@/lib/utils.ts'
import { MENU_SELECT_TOGGLE_DURATION } from '@/lib/constants/animationsSettings.ts'

type PropsT = {
  className?: string
  open?: boolean
  handleClick?: () => void
}
export default function OverlayBackdrop({ className, open, handleClick }: PropsT) {
  return (
    <div
      onClick={handleClick}
      className={cn(
        `fixed bottom-0 left-0 top-0 z-[1000] w-full bg-black/50 md:w-[var(--sidebar-width)] md:bg-black/10`,
        open ? `opacity-100` : `pointer-events-none opacity-0`,
        MENU_SELECT_TOGGLE_DURATION,
        className,
      )}
    ></div>
  )
}
